import Flickity from './flickity';
import imagesLoaded from 'imagesloaded';

export default class FeaturedSpeakers {

	constructor(element) {
		this.element = element;
		this.slider = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-speakers__slider') : undefined;
	}
	
	init() {
		this.initSlider();
	}

	initSlider() {
		if (this.slider instanceof HTMLElement) {
			imagesLoaded(this.slider, { background: true }, () => {
				new Flickity(this.slider, {
					contain: true,
					cellAlign: 'center',
					prevNextButtons: false,
					groupCells: true,
				});
			});
		}
	}
}